module.exports = __webpack_public_path__ + "img/hero-1.a95709c0.jpg";